import { render } from "./Contracts.vue?vue&type=template&id=0016f074&scoped=true&ts=true"
import script from "./Contracts.vue?vue&type=script&lang=ts"
export * from "./Contracts.vue?vue&type=script&lang=ts"

import "./Contracts.vue?vue&type=style&index=0&id=0016f074&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0016f074"]])

export default __exports__